'use client';

import {
  PointStatus,
  useAddressStore,
} from '@/entities/address/model/use-address-store';
import { useBrands } from '@/entities/brand/api/query';
import { Container } from '@/shared/ui';
import { Flex, Heading } from '@chakra-ui/react';
import { useQueryState } from 'nuqs';
import { HiOutlineFolderOpen } from 'react-icons/hi2';
import BrandCard from './brand-card';
import BrandSkeleton from './brand-skeleton';

const BrandsList = () => {
  const [tagsParam] = useQueryState('tags');
  const [categoryId] = useQueryState('category');
  const { points } = useAddressStore();

  const activePoint = points?.find(
    (point) => point.status === PointStatus.ACTIVE
  );

  const { data, isLoading } = useBrands({
    page: 1,
    limit: 10,
    shipper_tag_ids: tagsParam || undefined,
    shipper_category_id: categoryId || undefined,
    long: activePoint?.location?.[1],
    lat: activePoint?.location?.[0],
  });

  if (data?.count === '0') {
    return (
      <Container
        direction="column"
        w="full"
        alignItems="center"
        mt="12"
        gap="2"
      >
        <HiOutlineFolderOpen size={80} color="#a1a1aa" strokeWidth={1.2} />
        <Heading
          as="h2"
          size="xl"
          fontWeight="semibold"
          color="gray.500"
          pl="4"
        >
          No results
        </Heading>
      </Container>
    );
  }

  return (
    <Container direction="column" gap="4" w="full">
      {isLoading ? (
        <Flex direction="column" gap="8">
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <BrandSkeleton key={item} />
          ))}
        </Flex>
      ) : (
        <Flex direction="column" gap="8">
          {data?.aggregator_shippers.map((brand) => (
            <BrandCard key={brand.id} brand={brand} />
          ))}
        </Flex>
      )}
    </Container>
  );
};

export default BrandsList;
